var modules_f92dd299 = {"container":"_nrav0o","trigger-backdrop":"_1yio74z","overlay":"_lj0i2n","backdrop":"_5g00hf","header":"_nfdgwt","content":"_7egkxm","close":"_qwtyfv"};
import "../../../assets/CecYQGh7.css";

export { modules_f92dd299 as default };
//# sourceMappingURL=Popover.module.less.js.map
